import { FEATURES } from "../content/features";
import { Icon } from "./Icon";
import "./styles/FeatureGrid.css";

export function FeatureGrid() {
  return (
    <ul className="feature-grid">
      {FEATURES.map((feature) => (
        <li key={feature.id} className="feature-grid__item">
          <span className="feature-grid__icon"><Icon name={feature.icon} /></span>
          <h2>{feature.title}</h2>
          <p>{feature.description}</p>
        </li>
      ))}
    </ul>
  );
}
